import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { ReactComponent as OnyxLogoBlack } from '@/assets/images/ONYX-Logo-Black.svg';

const FeatureDisabled: React.FC = () => {
    const navigate = useNavigate();

    const handleGoToHomepage = () => {
        navigate('/dashboard');
    }

    return (
        <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center px-4">
            <div className="max-w-md w-full text-center">
                <div className="bg-white dark:bg-gray-800 shadow-xl rounded-lg p-8 border border-gray-200 dark:border-gray-700">
                    {/* ONYX Logo */}
                    <div className="mb-6">
                        <OnyxLogoBlack className="h-10 w-auto mx-auto dark:filter dark:invert" />
                    </div>

                    <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-onyx-red/10 dark:bg-onyx-red/20 mb-4">
                        <ExclamationTriangleIcon className="h-10 w-10 text-onyx-red" />
                    </div>

                    <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-2 onyx-headline">
                        Feature Disabled
                    </h1>

                    <p className="text-gray-600 dark:text-gray-400 mb-6 onyx-body">
                        The feature you have tried to access is not enabled.
                    </p>

                    <div className="space-y-4">
                        <button
                            onClick={handleGoToHomepage}
                            className="w-full px-4 py-2 bg-onyx-bright-blue text-white font-fk-medium rounded-lg hover:bg-onyx-dark-blue transition-colors focus:outline-none focus:ring-2 focus:ring-onyx-bright-blue focus:ring-offset-2 onyx-button"
                        >
                            Return to Dashboard
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default FeatureDisabled;